import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import 'rxjs/add/operator/switchMap';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { PagaresService } from "../../../services/pagares.service";
import { ArchivosCreditosService } from "../../../services/archivos-creditos.service";
/**Upload */
import { Http } from '@angular/http';

@Component({
  selector: 'formulario-pagare',
  templateUrl: './formulario-pagare.component.html'
})
export class FormularioPagareComponent implements OnInit {

    public static readonly ARCHIVO_PAGARE : number = 8;

    @Input() public idCreditos: number = null;
    @Input() public isCompleted: boolean = false;
    @Input() public isEditable: boolean = false;
    @Output() public onDataUpdated: EventEmitter<string> = new EventEmitter;

    //Pagare
    public archivo: any = null;
    //UI attributes
    public uploadingContract: boolean = false;
    public errors: any = {};
    public isLoadComplete: boolean = false;
    //Spinners
    public creatingContract: boolean = false;
    public isCreatingPagare: boolean = false;

    constructor(
      private helperService: HelpersService,
      private pagaresService: PagaresService,
      private archivosService: ArchivosCreditosService
    ){

    }

    public ngOnInit() {
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.idCreditos ) {
            this.getArchivo(this.idCreditos);
        }
    }
      
    public downloadPagare() {
        //Mostrar spinner
        this.isCreatingPagare = true;
        this.pagaresService.download(this.idCreditos).subscribe(
          (response)=>
          {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
            //Ocultar spinner ya que el archivo termino de crearse
            this.isCreatingPagare = false;
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }

    private getArchivo(idCreditos : number){
        //TODO: Manejar cuando el id no retorna un crédito valido
        
        this.archivosService.get(idCreditos, FormularioPagareComponent.ARCHIVO_PAGARE).subscribe(
          (response)=>
          {
            const archivos = response.json().content;
            
            if(archivos && archivos.length > 0){
                //Solo debería haber un archivo de pagaré por crédito
                this.archivo = archivos[0];
            }

            this.isLoadComplete = true;
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            
            if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors); 
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }

    /**
     * Upload files
     */
    public fileChange(event) {
        //Show spinner
        this.uploadingContract = true;
  
        let fileInfo = 
        {
            idCreditos : this.idCreditos,
            tipo: FormularioPagareComponent.ARCHIVO_PAGARE,
            descripcion: ''
        };
  
        let observableResponse = this.archivosService.save(event, fileInfo);
  
        if(!observableResponse){
          //Si al hacer el Upload del archivo se cancela la carga, cae en este escenario 
          this.uploadingContract = false;
          return;
        }
  
        observableResponse.subscribe(
            (response)=>
            {
                let archivo = response.json().content;

                if(this.archivo){
                    //Si ya existía un archivo asociado al pagaré lo eliminamos
                    this.delete(this.archivo.id, false);
                }

                this.archivo = archivo;
                //Hide spinner
                this.uploadingContract = false;
                //Notify result
                this.helperService.notification('Pagaré agregado', 'Se ha agregado exitosamente el pagaré', 'success');
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);
        
                if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );        
    }

    public downloadFile(idFile : number) {
        this.archivosService.getFile(idFile).subscribe(
          (response)=>
          {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }

    public delete(idFile : number, clearModel: boolean = true){
        this.archivosService.delete(idFile).subscribe(
            (response)=>
            {
                if(clearModel){
                    //Eliminar el archivo de la lista, para que no se muestre en el formulario. En el escenario normal se borra el archivo asignado.
                    //Cuando se hace un upload de un archivo existiendo ya un archivo asociado, el clear del modelo se hace en un paso anterior a este borrado.
                    this.archivo = null;
                    this.helperService.notification('Pagaré eliminado', 'Se ha eliminado exitosamente el pagaré ', 'success');
                }
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
  
            if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/creditos/components/formulario-pagare/formulario-pagare.component.ts